





























export default {
  props: {
    showExerciseSessionIsCompleteDialog: {
      type: Boolean,
      default: false,
    },
    exerciseSessionDate: {
      type: String,
      required: true,
    },
    exerciseSessionStartTime: {
      type: String,
      required: true,
    },
    exerciseSessionEndTime: {
      type: String,
      required: true,
    },
    exerciseSessionDuration: {
      type: String,
      required: true,
    },
    exerciseSessionParticipantsNumber: {
      type: Number,
      required: true,
    },
  },
  methods: {
    pushPatientRecordRoute() {
      this.$emit('pushPatientRecordRoute')
    },
  },
}
